import axios from "axios";

// Same-origin by default: nginx (prod) and the Vite dev proxy both route /api
// to the backend. An absolute http:// default would be blocked as mixed content
// once the app is served over HTTPS.
const API_URL = import.meta.env.VITE_API_URL || "/api";

const api = axios.create({
	baseURL: API_URL,
	headers: {
		"Content-Type": "application/json",
	},
});

let _store = null;

/**
 * Called once from main.jsx / index.jsx to wire up the Redux store
 * so the interceptor can dispatch logout without circular imports.
 */
export function injectStore(store) {
	_store = store;
}

// Add auth token to requests
api.interceptors.request.use((config) => {
	const token = localStorage.getItem("token");

	if (token) {
		config.headers.Authorization = `Bearer ${token}`;
	}
	return config;
});

// Handle auth errors
api.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response?.status === 401) {
			const isAuthEndpoint = error.config?.url?.includes("/auth/");

			// If a non-auth endpoint returns 401 → the token has expired.
			// Clear credentials, redirect to login with a message.
			if (!isAuthEndpoint) {
				localStorage.removeItem("token");
				if (_store) {
					_store.dispatch({ type: "auth/logout" });
				}
				if (!window.location.pathname.includes("/login")) {
					window.location.href = "/login?expired=true";
				}
				// Suppress further promise rejections for this request
				return new Promise(() => {});
			}
		}
		// The organisation was suspended while logged in (JwtAuthenticationFilter)
		if (
			error.response?.status === 403 &&
			error.response?.data?.code === "ORGANISATION_SUSPENDED"
		) {
			localStorage.removeItem("token");
			if (_store) {
				_store.dispatch({ type: "auth/logout" });
			}
			if (!window.location.pathname.includes("/login")) {
				window.location.href = "/login?suspended=true";
			}
			return new Promise(() => {});
		}
		return Promise.reject(error);
	},
);

export default api;
